import axios from "axios";
import {
  TENANTREGISTER_REGISTER_REQUEST,
  TENANTREGISTER_REGISTER_SUCCESS,
  TENANTREGISTER_REGISTER_FAIL,
  TENANTREGISTER_RESEND_VERIFICATION_EMAIL_REQUEST,
  TENANTREGISTER_RESEND_VERIFICATION_EMAIL_SUCCESS,
  TENANTREGISTER_RESEND_VERIFICATION_EMAIL_FAIL,
  TENANTREGISTER_VERIFY_EMAIL_BYCODE_REQUEST,
  TENANTREGISTER_VERIFY_EMAIL_BYCODE_SUCCESS,
  TENANTREGISTER_VERIFY_EMAIL_BYCODE_FAIL,
  TENANTREGISTER_REGISTER_GOOGLE_REQUEST,
  TENANTREGISTER_REGISTER_GOOGLE_SUCCESS,
  TENANTREGISTER_REGISTER_GOOGLE_FAIL,
  TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_REQUEST,
  TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_SUCCESS,
  TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_FAIL,
} from "../constants/tenantRegisterConstants";
import { AUTH_LOGIN_SUCCESS } from "../constants/authConstants";

// Register Tenant
export const registerTenantAction =
  (
    // clinicName,
    registrationEmail,
    password,
    repeatPassword,
    language
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: TENANTREGISTER_REGISTER_REQUEST });

      // API call to register the tenant
      const { data } = await axios.post("/api/tenant-register/register", {
        // clinicName,
        registrationEmail,
        password,
        repeatPassword,
        language,
      });

      // console.log("ACTION data:", data);

      dispatch({
        type: TENANTREGISTER_REGISTER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANTREGISTER_REGISTER_FAIL,
        payload: error.response?.data.message || error.message,
      });
    }
  };

// Verify Email
export const verifyTenantEmailByCodeAction =
  (email, verificationCode, language) => async (dispatch) => {
    try {
      dispatch({ type: TENANTREGISTER_VERIFY_EMAIL_BYCODE_REQUEST });

      const { data } = await axios.post(
        "/api/tenant-register/verify-email-by-code",
        { registrationEmail: email, verificationCode, language }
      );

      dispatch({
        type: TENANTREGISTER_VERIFY_EMAIL_BYCODE_SUCCESS,
        payload: data,
      });

      // console.log("VERIFY DATA:", data);

      // STORE USER INFO
      dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: data,
      });

      localStorage.setItem("userInfo", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: TENANTREGISTER_VERIFY_EMAIL_BYCODE_FAIL,
        payload: error.response?.data?.message || "Error verifying email",
      });
    }
  };

export const registerTenantGoogleAction =
  (googleData, language) => async (dispatch) => {
    try {
      dispatch({ type: TENANTREGISTER_REGISTER_GOOGLE_REQUEST });

      const { data } = await axios.post(
        "/api/tenant-register/register-google",
        { ...googleData, language }
      );

      dispatch({
        type: TENANTREGISTER_REGISTER_GOOGLE_SUCCESS,
        payload: data,
      });

      // ✅ Immediately dispatch login success so Redux is updated
      dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: data,
      });

      // ✅ Save Token & Redirect
      localStorage.setItem("userInfo", JSON.stringify(data));

      // ✅ Redirect using the slug
      if (data.slug) {
        window.location.href = `/${data.slug}/onboarding`;
      } else {
        window.location.href = "/onboarding"; // fallback just in case
      }
    } catch (error) {
      dispatch({
        type: TENANTREGISTER_REGISTER_GOOGLE_FAIL,
        payload: error.response?.data.message || error.message,
      });
    }
  };

export const resendVerificationEmailAction =
  (email, language) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANTREGISTER_RESEND_VERIFICATION_EMAIL_REQUEST });

      const { data } = await axios.post(
        `/api/tenant-register/resend-verification-email`,
        {
          registrationEmail: email,
          language,
        }
      );

      dispatch({
        type: TENANTREGISTER_RESEND_VERIFICATION_EMAIL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANTREGISTER_RESEND_VERIFICATION_EMAIL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const verifyTenantEmailByTokenAction = (token) => async (dispatch) => {
  try {
    dispatch({ type: TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_REQUEST });

    const { data } = await axios.post(
      "/api/tenant-register/verify-email-by-token",
      { token }
    );

    dispatch({
      type: TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_SUCCESS,
      payload: data,
    });

    // ✅ Immediately log the user in
    dispatch({
      type: AUTH_LOGIN_SUCCESS,
      payload: data,
    });

    // ✅ Save session
    localStorage.setItem("userInfo", JSON.stringify(data));

    // ✅ Redirect to onboarding
    if (data.slug) {
      window.location.href = `/`;
    } else {
      window.location.href = "/";
    }
  } catch (error) {
    dispatch({
      type: TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_FAIL,
      payload:
        error.response?.data?.message || "Failed to verify email by token",
    });
  }
};
